export interface ToolbarButton {
  key: string;
  link: string;
  status?: string;
}

// Configuración de botones del toolbar
export const toolbarButtons: ToolbarButton[] = [
  { key: 'all', link: '#' },
  { key: 'pending_review', link: '#', status: 'PENDING_REVIEW' },
  { key: 'in_progress', link: '#', status: 'IN_PROGRESS' },
  { key: 'paid', link: '#', status: 'PAID' },
  { key: 'failed', link: '#', status: 'FAILED' },
  { key: 'rejected', link: '#', status: 'REJECTED' },
  { key: 'returned', link: '#', status: 'RETURNED' },
  { key: 'cancelled', link: '#', status: 'CANCELLED' },
];
